import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import TableServices from "./TableServices";

const initialState = {
  table: null,
  tables: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  message: "",
};

// createbase thunkApi
export const createTable = createAsyncThunk(
  "table/createTable",
  async (baseData, thunkAPI) => {
    try {
      return await TableServices.createTable(baseData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getTables = createAsyncThunk(
  "table/getTables",
  async (_, thunkAPI) => {
    try {
      return await TableServices.getTables();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateTable = createAsyncThunk(
  "table/updateTable",
  async (baseData, thunkAPI) => {
    try {
      return await TableServices.updateTable(baseData);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteTable = createAsyncThunk(
  "table/deleteTable",
  async (id, thunkAPI) => {
    try {
      return await TableServices.deleteTable(id);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const attachTable = createAsyncThunk(
  "table/attachTable",
  async (tableNo, thunkAPI) => {
    try {
      return await TableServices.attachTable(tableNo);
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const tableSlice = createSlice({
  name: "table",
  initialState,
  reducers: {
    RESET_TABLE(state) {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      // create table
      .addCase(createTable.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(createTable.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.table = action.payload;
        console.log(action.payload);
        toast.success("Create new base successfully");
      })

      .addCase(createTable.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.table = null;
        toast.error(action.payload);
      })

      .addCase(getTables.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(getTables.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.tables = action.payload.data;
      })

      .addCase(getTables.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.tables = null;
        toast.error(action.payload);
      })

      .addCase(updateTable.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(updateTable.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.table = action.payload.data;
        console.log(action.payload);
      })

      .addCase(updateTable.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.table = null;
        toast.error(action.payload);
      })
      .addCase(deleteTable.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(deleteTable.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.table = null;
        toast.success(action.payload);
        console.log(action.payload);
      })

      .addCase(deleteTable.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        state.table = null;
        toast.error(action.payload);
      })
      .addCase(attachTable.pending, (state, action) => {
        state.isLoading = true;
      })

      .addCase(attachTable.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        console.log(action.payload);
      })

      .addCase(attachTable.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
        toast.error(action.payload);
      });
  },
});

export const { RESET_TABLE } = tableSlice.actions;
export const selectTable = (state) => state.table.table;
export const selectTables = (state) => state.table.tables;
export const selectTableSuccess = (state) => state.table.isSuccess;

export default tableSlice.reducer;
